const install = (Vue, vm) => {
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let wxLogin = (params = {}) => vm.$u.http.get('web/account/wxLogin',{ params });	// 登录
	let wxAuthPhone = (data = {}) => vm.$u.http.post('web/account/wxAuthPhone', data);	// 授权手机号
	let getMemberInfo = (params = {}) => vm.$u.http.get('web/member/getMemberInfo',{ params });	// 获取个人信息
	let updateMember = (data = {}) => vm.$u.http.post('web/member/editMemberInfo', data);	// 更新个人信息
	let getBannerList = (params = {}) => vm.$u.http.get('web/config/getBannerList',{ params });	// 获取banner列表
    let getBannerDetail = (params = {}) => vm.$u.http.get('web/config/getBannerDetail',{ params });	// 获取banner详情 
	let getNearbyShopList = (data = {}) => vm.$u.http.post('web/shopInfo/nearby', data);	// 获取附近店铺列表
	let getShopDetail = (data = {}) => vm.$u.http.post('web/shopInfo/detail', data);	// 获取店铺详情
	let getCitySizeList = (params = {}) => vm.$u.http.get('web/config/getCitySizeList',{ params });	// 获取城市已开通物品尺寸
	let createOrder = (data = {}) => vm.$u.http.post('web/order/create', data);	// 创建订单
	let getCityByName = (params = {}) => vm.$u.http.get('web/config/getCityByCode',{ params });	// 根据城市名称查询城市信息
	let getCategoryList = (params = {}) => vm.$u.http.get('web/config/getCategoryList',{ params });	// 获取物品分类列表
	let calculateLocalPrice = (data = {}) => vm.$u.http.post('web/config/calculateLocalPrice', data);	// 计算就地存取预估费用
	let calculateRemotePrice = (data = {}) => vm.$u.http.post('web/config/calculateRemotePrice', data);	// 计算远程存取预估费用
	let getPlatformAboutUs = (params = {}) => vm.$u.http.get('web/config/getPlatformAboutUs',{ params });	// 获取平台关于我们信息
	let findListAddr = (params = {}) => vm.$u.http.get('web/addr/list',{ params });	// 获取地址簿列表
	let createAddr = (data = {}) => vm.$u.http.post('web/addr/create', data);	// 创建地址簿
	let deleteAddr = (params = {}) => vm.$u.http.get(`web/addr/delete/${params.id}`);	// 删除地址簿
	let setDefaultAddr = (params = {}) => vm.$u.http.post(`web/addr/setDefault/${params.id}`);	// 设置默认地址簿
	let updateAddr = (data = {}) => vm.$u.http.post('web/addr/updateById', data);	// 更新地址簿信息
	let treeList = (data = {}) => vm.$u.http.post('web/config/treeList', data);	// 全部区划树形查询
	let getOrderDetail = (orderId) => vm.$u.http.get(`web/order/detail/${orderId}`);	// 获取订单详情
	let applyShop = (data = {}) => vm.$u.http.post('web/shopInfo/apply', data);	// 门店入驻申请
	let getMyShop = (params = {}) => vm.$u.http.get('web/shopInfo/myShop',{ params });	// 获取我的店铺信息
	let payDeposit = (data = {}) => vm.$u.http.post('web/shopInfo/payDeposit', data);	// 门店入驻支付
	let logOut = (params = {}) => vm.$u.http.get('web/account/logOut',{ params });	// 退出登录
	let getOpenCityList = (params = {}) => vm.$u.http.get('web/config/getOpenCityList',{ params });	// 获取已开通城市列表
	let getMemberNoticePage = (data = {}) => vm.$u.http.post('web/config/memberNoticePage', data);	// 获取会员通知列表
	let shopNoticePage = (data = {}) => vm.$u.http.post('web/config/shopNoticePage', data);	// 获取门店通知列表
	let shopLogin = (data = {}) => vm.$u.http.post('web/account/shopLogin', data);	// 门店登录
	let shopSilentLogin = (params = {}) => vm.$u.http.get('web/account/shopSilentLogin',{ params });	// 门店静默登录
	let shopStatistics = (params = {}) => vm.$u.http.get('web/wallet/shopStatistics',{ params });	// 门店钱包统计
	let shopSummary = (data = {}) => vm.$u.http.post('web/revenue/shopSummary', data);	// 门店营收统计
	let shopPage = (data = {}) => vm.$u.http.post('web/revenue/shopPage', data);	// 门店营收分页查询
	let shopApply = (data = {}) => vm.$u.http.post('web/wallet/shopApply', data);	// 门店提现申请
	let getShopInfo = (params = {}) => vm.$u.http.get('web/shopInfo/getShopInfo',{ params });	// 获取门店信息
	let changePassword = (data = {}) => vm.$u.http.post('web/shopInfo/changePassword', data);	// 门店修改密码
	let myOrderPage = (data = {}) => vm.$u.http.post('web/order/myPage', data);	// 会员订单分页
	let shopOrderPage = (data = {}) => vm.$u.http.post('web/order/shopPage', data);	// 门店订单分页
	let deleteOrder = (data = {}) => vm.$u.http.post('web/order/delete/'+data.orderId, data);	// 删除订单
	let cancelOrder = (data = {}) => vm.$u.http.post('web/order/cancel', data);	// 取消订单
	let confirmReceipt = (data = {}) => vm.$u.http.post('web/order/confirmReceipt/'+data.orderId, data);	// 会员确认收货 
	let continuePayOrder = (data = {}) => vm.$u.http.post('web/order/continuePay/'+data.orderId, data);	//继续发起支付
	let orderComment = (data = {}) => vm.$u.http.post('web/order/comment', data);	//订单评价
	let payOverdueFee = (data = {}) => vm.$u.http.post('web/order/payOverdueFee/'+data.orderId, data);	//继续发起支付
	let shopSalesStats = (params = {}) => vm.$u.http.get('web/shopInfo/salesStats',{ params });	//门店销售统计
	let shopOrderDetail = (params = {}) => vm.$u.http.get('web/order/shopDetail',{ params });	//门店订单详情
	let shopVerifyOrder = (data = {}) => vm.$u.http.post('web/order/shopVerify',data);	//门店核销收件
	let storeOutOrder = (data = {}) => vm.$u.http.post('web/order/storeOut',data);	//门店核销出货
	let confirmArrivedOrder = (data = {}) => vm.$u.http.post('web/order/confirmArrived',data);	//确认到店
	let getShopInfoDetail= (params = {}) => vm.$u.http.get('web/shopInfo/shopDetail',{ params });	// 获取我的店铺信息
	let logOutShop= (params = {}) => vm.$u.http.get('web/account/logOutShop',{ params });	// 门店退出登录
	let getActiveOrderTip= (params = {}) => vm.$u.http.get('web/config/getActiveOrderTip',{ params });	// 首页进行中订单提示
	let maintainInfo= (data = {}) => vm.$u.http.post('web/shopInfo/maintainInfo',data);	// 查询门店维护信息
	let maintainShopInfo= (data = {}) => vm.$u.http.post('web/shopInfo/maintain',data);	// 查询门店维护信息
	let sendSmsCode= (params = {}) => vm.$u.http.get('web/member/sendSmsCode',{ params });	// 发送短信验证码
	let verifyCode= (params = {}) => vm.$u.http.get('web/member/verifyCode',{ params });	// 验证短信验证码
	let getContactInfo= (params = {}) => vm.$u.http.get('web/member/getContactInfo',{ params });	// 获取用户收件信息
	let updateUserPhone= (data = {}) => vm.$u.http.post('web/member/updateUserPhone',data);	// 更新用户手机号
	let printOrderLabel = (params = {}) => vm.$u.http.get('web/shopInfo/printOrderLabel/'+params.orderId,{ params });	//门店订单打印
	let checkOperationRadius = (data = {}) => vm.$u.http.post('web/config/checkOperationRadius',data);	// 检查门店操作半径
	let checkShopOperationRadius = (data = {}) => vm.$u.http.post('web/config/checkShopOperationRadius',data);	// 检查门店操作半径
	let locationTagShopCount = (params = {}) => vm.$u.http.get('web/shopInfo/locationTagShopCount',{ params });	// 门店标签统计数量
	let findPage = (data = {}) => vm.$u.http.post('web/memberCoupon/findPage',data);	// 会员优惠券分页查询
	let claimCoupon = (params = {}) => vm.$u.http.get('web/memberCoupon/claim',{ params });	// 会员优惠券领取使用
	let invoicePage = (data = {}) => vm.$u.http.post('web/invoice/page',data);	// 发票申请分页查询
	let invoiceApply = (data = {}) => vm.$u.http.post('web/invoice/apply',data);	// 发票申请提交
	let sendEmail = (data = {}) => vm.$u.http.post('web/invoice/sendEmail',data);	// 发送至邮箱
	let driverKpi = (data = {}) => vm.$u.http.post('web/revenue/shopKpi',data);	// 司机KPI
	let shopLuggageType = (data = {}) => vm.$u.http.post('web/revenue/shopLuggageType',data);	// 门店行李类型
	let pendingCount = (params = {}) => vm.$u.http.get('web/memberCoupon/pendingCount',{ params });	// 会员优惠券待使用数量
	let timeline = (orderId) => vm.$u.http.get(`web/order/timeline/${orderId}`);	// 会员查询订单时间轴
	let shopTimeline = (orderId) => vm.$u.http.get(`web/order/shop/timeline/${orderId}`);	// 门店查询订单时间轴


	vm.$u.api = {
		printOrderLabel,
		getActiveOrderTip,
		logOutShop,
		maintainShopInfo,
		maintainInfo,
		getShopInfoDetail,
		storeOutOrder,
		confirmArrivedOrder,
		shopVerifyOrder,
		shopOrderDetail,
		shopSalesStats,
		payOverdueFee,
		orderComment, 
		confirmReceipt,
		cancelOrder,
		deleteOrder,
		continuePayOrder,
		myOrderPage,
		shopOrderPage,
		wxLogin,
		wxAuthPhone,
		getMemberInfo,
		getMemberInfo,
		updateMember,
		getBannerList,
		getBannerDetail,
		getNearbyShopList,
		getShopDetail,
		getCitySizeList,
		createOrder,
		getCityByName,
		getCategoryList,
		calculateLocalPrice,
		calculateRemotePrice,
		getPlatformAboutUs,
		findListAddr,
		createAddr,
		deleteAddr,
		setDefaultAddr,
		updateAddr,
		treeList,
		getOrderDetail,
		applyShop,
		getMyShop,
		payDeposit,
		logOut,
		getOpenCityList,
		getMemberNoticePage,
		shopLogin,
		shopSilentLogin,
		shopStatistics,
		shopSummary,
		shopPage,
		shopApply,
		getShopInfo,
		shopNoticePage,
		changePassword,
		sendSmsCode,
		verifyCode,
		updateUserPhone,
		getContactInfo,
		checkOperationRadius,
		checkShopOperationRadius,
		locationTagShopCount,
		findPage,
		claimCoupon,
		invoicePage,
		invoiceApply,
		sendEmail,
		driverKpi,
		shopLuggageType,
		pendingCount,
		timeline,
		shopTimeline
	};
}

export default { install }